<template>
    <v-container fluid grid-list-xs class="AutoLoginPage general-container" v-if="hasErrors">

        <v-layout align-center justify-center row fill-height offset-xs1 >
                <v-card class="auto-login-card">
                    <v-toolbar color="error" dark>
                        <v-toolbar-title>{{text('api.autologin.error')}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="subheading">
                        {{text('api.autologin.dataIncorrect')}}
                    </v-card-text>

                    <v-list two-line>
                        <template v-for="(item, index) in errorMessages">
                            <v-subheader  v-if="item" :key="item" >
                                {{ item }}
                            </v-subheader>
                        </template>
                    </v-list>
                </v-card>
        </v-layout>

    </v-container>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';


export default {
        name: 'AutoLoginPage',
        components: {
        },
        data() {
            return {
                /* username: '',
                password: '',*/
                valid: true,
                productCode: null,
                isLoggedIn: null,
                hasValidProductCode: false,
                pid: null,
                msitat: null,
                assessmentToken: null,
                assessmentLanguage: null,
                username: '',
                mustShowPatientPanel: true,
                errorMessages: [],
                sex: null,
                dob: null,
                pregnancy: null,
                wop: null,
                woc: null,
                emergency: null,
                fetmov: null,
                vitparam: null,
                heartrate: null,
                brrate: null,
                oxsat: null,
                systbp: null,
                diastbp: null,
                btemp: null,
                blsugmmoll:null,
                blsugmgdl: null,
                breathing: null,
                hrtcirc: null,
                neuroment: null,
                abdomen: null,
                trauma: null,
                other: null,

                nameRules: [
                    (v) => !!v ||  this.text("api.login.username") + ' ' + this.text("api.error.isRequired"),
                    (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
                ],
                password: '',
                passwordRules: [
                    (v) => !!v ||  this.text("api.login.password") + ' '  + this.text("api.error.isRequired"),
                    (v) =>  v && v.length >= 1 || 'Password must be valid'
                ],
                mustShowPriorityList: false,
                mustShowEvaluationScreen: false,
                dc: null,
                emergind: null
            }
        },
        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                sexQuestionAnswers: 'SubmittedValuesStore/getSexQuestionAnswers',
                startQuestionCodes: 'SubmittedValuesStore/getStartQuestionCodes',
                ageQuestionAnswers: 'SubmittedValuesStore/getAgeQuestionAnswers',
                validProductCodes: 'SubmittedValuesStore/getValidProductCodes',
                savedErrorMessages: 'SubmittedValuesStore/getErrorMessages',
                savedErrorKey: 'SubmittedValuesStore/getErrorKey',
                getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList'
            }),

            selectedLang: {
                get () {
                    return this.$store.state["TranslationStore"].selectedLanguage;
                },
                set (newVal) {
                    this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
                }
            },

            hasErrors: function() {
              return this.errorMessages.length > 0 ?  true : false;
            }
        },

        beforeCreate() {
            // Reset stores.
            this.$store.commit('ProductListStore/resetStore');
            this.$store.commit('AssessmentStartStore/resetStore');
            this.$store.commit('ChooseMainSymptomStore/resetStore');
            this.$store.commit('SymptomsQuestionsStore/resetStore');
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('ScoringStore/resetStore');
            this.$store.commit('SummaryStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');
            // this.$store.commit('SubmittedValuesStore/resetStore');
        },

        created() {
            if(!this.isErrorsExists()){
                this.login();
            }
        },

        watch: {
            $route(to, from) {
                if (!this.isErrorsExists()) {
                    this.login();
                }
            }
        },

        methods: {

            login() {

                this.getQueryStringParameters();
                this.errorMessages = [];

                //validate
                if (typeof this.productCode === "undefined"){
                  this.errorMessages.push(this.text("api.autologin.productcode.missing"))
                }

                if (typeof this.sex !== "undefined" && ( this.sex !== 'm' && this.sex !== 'f')){
                   this.errorMessages.push(this.text("api.autologin.sex.invalid"));
                }

                if (typeof this.dob !== "undefined" && !this.isValidDate(this.dob)){
                  this.errorMessages.push(this.text("api.autologin.dob.invalid"));
                }

                if (this.errorMessages.length > 0){
                    return;
                }


                let promiseLogin = this.$store.dispatch("UserStore/submitLogin", {
                    username: this.userName,
                    password: this.password,
                    autologin: true
                });

                promiseLogin.then((response) => {
                    this.isLoggedIn = true;

                    this.selectProduct();

                });
                promiseLogin.catch((error) => {
                    if (typeof error === "string") {
                        alert(error);
                    }
                    else if (typeof error.serverResponse !== "undefined"
                            && typeof error.serverResponse.data !== "undefined"
                            && typeof error.serverResponse.data.returnCode !== "undefined"
                            && error.serverResponse.data.returnCode === 102) {

                            console.log(this.text("api.login.badlogin"));

                    }
                    // clear out all submitted values if there are any
                    this.$store.commit("SubmittedValuesStore/resetStore");
                    this.errorMessages.push(this.text("api.login.badlogin"));
                });

            },

            getQueryStringParameters() {
                 // get the parameters from the query string and remove any whitespace
                let queryObj = this.$route.query;

                try {
                    this.userName = this.getValueTrim(queryObj, "username");
                    this.password = this.getValueTrim(queryObj, "password");
                    this.msitat = this.getValueTrim(queryObj, "msitat");
                    this.assessmentToken = this.getValueTrim(queryObj, "assessmenttoken");
                    this.assessmentLanguage = this.getValueTrim(queryObj, "language");
                    this.productCode = this.getValueTrim(queryObj, "productcode");
                    this.mustShowPatientPanel = this.getValueTrim(queryObj, "patientpanel");
                    this.pid = this.getValueTrim(queryObj, "pid");
                    this.mustShowPriorityList = this.getValueTrim(queryObj, "prioritylist");
                    this.mustShowEvaluationScreen = this.getValueTrim(queryObj, "evaluationscreen");
                    this.dc = this.getValueTrim(queryObj, "dc");
                    this.emergind = this.getValueTrim(queryObj, "emergind");
                    this.sex = this.getValueTrim(queryObj, "sex");
                    this.dob = this.getValueTrim(queryObj, "dob");
                    this.pregnancy = this.getValueTrim(queryObj, "pregnancy");
                    this.wop = this.getValueTrim(queryObj, "wop");
                    this.woc = this.getValueTrim(queryObj, "woc");
                    this.emergency = this.getValueTrim(queryObj, "emergency");
                    this.fetmov = this.getValueTrim(queryObj, "fetmov");
                    this.vitparam = this.getValueTrim(queryObj, "vitparam");
                    this.heartrate = this.getValueTrim(queryObj, "heartrate");
                    this.brrate = this.getValueTrim(queryObj, "brrate");
                    this.oxsat = this.getValueTrim(queryObj, "oxsat");
                    this.systbp = this.getValueTrim(queryObj, "systbp");
                    this.diastbp = this.getValueTrim(queryObj, "diastbp");
                    this.btemp = this.getValueTrim(queryObj, "btemp");
                    this.blsugmmoll = this.getValueTrim(queryObj, "blsugmmoll");
                    this.blsugmgdl = this.getValueTrim(queryObj, "blsugmgdl");
                    this.breathing = this.getValueTrim(queryObj, "breathing");
                    this.hrtcirc = this.getValueTrim(queryObj, "hrtcirc");
                    this.neuroment = this.getValueTrim(queryObj, "neuroment");
                    this.abdomen = this.getValueTrim(queryObj, "abdomen");
                    this.trauma = this.getValueTrim(queryObj, "trauma");
                    this.other = this.getValueTrim(queryObj, "other");
                } catch (e) {
                    if (e['errorType'] != null && e['errorType'] === 'paramValueDuplicated') {
                        this.errorMessages.push(this.$text('api.autologin.parameters.duplicated'), e['paramName']);
                        return;
                    }
                }

                // This will tell if Patient Profile panel (on Assessment Start page) must be hidden.
                // Only need to set to sessionStorage with "false" value (if we need to hide Patient Profile panel), in all the other cases it will be shown by default.
                if (typeof this.mustShowPatientPanel !== "undefined" && this.mustShowPatientPanel.trim() == "false"){
                    sessionStorage.setItem('must-show-patient-panel', false);
                }
                else {
                    sessionStorage.removeItem('must-show-patient-panel');
                }

                // This will tell if Priority List is default view (only if value is true)
                if (typeof this.mustShowPriorityList !== "undefined" && this.mustShowPriorityList.trim() == "true"){
                    sessionStorage.setItem('must-show-priority-list', true);
                }
                else {
                    sessionStorage.removeItem('must-show-priority-list');
                }

                // This will tell if Evaluation Screen is visible (only if value is true)
                if (typeof this.mustShowEvaluationScreen !== "undefined" && this.mustShowEvaluationScreen.trim() == "true"){
                    sessionStorage.setItem('must-show-evaluation-screen', true);
                }
                else {
                    sessionStorage.removeItem('must-show-evaluation-screen');
                }

                // save some of them in the store for later use
                let patientProfileData = {};
                patientProfileData.pid = this.pid;
                this.$store.commit('SubmittedValuesStore/setPatientProfileData', patientProfileData);
                this.$store.commit('SubmittedValuesStore/setMsitat', this.msitat);
                this.$store.commit('SubmittedValuesStore/setAssessmentToken', this.assessmentToken);
                this.$store.commit('SubmittedValuesStore/setAssessmentLanguage', this.assessmentLanguage);
                this.$store.commit("SubmittedValuesStore/setPid", this.pid);
                this.$store.commit("SubmittedValuesStore/setDc", this.dc);
                this.$store.commit("SubmittedValuesStore/setEmergind", this.emergind);
                this.$store.commit("SubmittedValuesStore/setSex", this.sex);
                this.$store.commit("SubmittedValuesStore/setDob", this.dob);
                this.$store.commit("SubmittedValuesStore/setPregnancy", this.pregnancy);
                this.$store.commit("SubmittedValuesStore/setWeekOfPregnancy", this.wop);
                this.$store.commit("SubmittedValuesStore/setWeekOfChildbed", this.woc);
                this.$store.commit("SubmittedValuesStore/setEmergency", this.emergency);
                this.$store.commit("SubmittedValuesStore/setFetalMovements", this.fetmov);
                this.$store.commit("SubmittedValuesStore/setShowVitalParams", this.vitparam);
                this.$store.commit("SubmittedValuesStore/setHeartFrequency", this.heartrate);
                this.$store.commit("SubmittedValuesStore/setBreathFrequency", this.brrate);
                this.$store.commit("SubmittedValuesStore/setOxygeneLevel", this.oxsat);
                this.$store.commit("SubmittedValuesStore/setUpperBloodPressure", this.systbp);
                this.$store.commit("SubmittedValuesStore/setLowerBloodPressure", this.diastbp);
                this.$store.commit("SubmittedValuesStore/setBodyTemperature", this.btemp);
                this.$store.commit("SubmittedValuesStore/setBloodSugarMoll", this.blsugmmoll);
                this.$store.commit("SubmittedValuesStore/setBloodSugarMgdl", this.blsugmgdl);
                this.$store.commit("SubmittedValuesStore/setBreathing", this.breathing);
                this.$store.commit("SubmittedValuesStore/setHeartCirculation", this.hrtcirc);
                this.$store.commit("SubmittedValuesStore/setNeurologicalMentalState", this.neuroment);
                this.$store.commit("SubmittedValuesStore/setAbdomen", this.abdomen);
                this.$store.commit("SubmittedValuesStore/setTrauma", this.trauma);
                this.$store.commit("SubmittedValuesStore/setOther", this.other);

            },

            getValueTrim(queryObj, paramName) {
                try {
                    if (typeof queryObj[paramName] !== "undefined"){
                        return queryObj[paramName].trim();
                    }

                    return undefined;
                } catch (error) {

                    // When a query parameter is provided twice then paramValue will be an array with the two values, therefor paramValue.trim() will throw an error;
                    throw {
                        errorType: "paramValueDuplicated",
                        paramName: paramName
                    }
                }

            },

            selectProduct() {

                if (this.validProductCodes.includes(this.productCode)){
                    this.hasValidProductCode = true;
                } else {
                    this.errorMessages.push(this.text("api.autologin.productcode.invalid"));
                    return;
                }
                // select the product, when loaded go to the next page
                this.$store.dispatch('ProductListStore/selectProduct', this.productCode).then(() => {
                    this.moveOn();
                });

            },
            moveOn() {

                this.setLanguage();

                if (this.hasValidProductCode) {
                    if(!this.getMustShowAssessmentList) {
                        this.$router.push({path: '/assessment-start', query: {referral: 'autoLogin'}});
                    } else {
                        this.$router.push({path: '/assessment-start-list', query: {referral: 'autoLogin'}});
                    }
                } else {
                    this.$store.commit("SubmittedValuesStore/resetStore");

                    let sessionStorageHomeRouteName = sessionStorage.getItem("smass-home-route");
                    if (sessionStorageHomeRouteName !== null && sessionStorageHomeRouteName === "PF_ChatBotPage") {
                        // PATHFINDER
                        this.$router.push({name: 'PF_ChatBotPage'}).then(() => {
                            sessionStorage.removeItem("crtChatbotSection");
                            window.location.reload();
                        });
                    }
                    else {
                        // PRO
                        this.$router.push({name: 'HomePage'});
                    }
                }

            },

            setLanguage() {
                const currentLang = this.selectedLang;
                if (currentLang !== this.assessmentLanguage) {
                    if (this.languageList.includes(this.assessmentLanguage)) {
                        this.selectedLang = this.assessmentLanguage;
                        this.$store.commit("TranslationStore/setSelectedLanguage", this.assessmentLanguage);
                    }
                }
            },

            isValidDate: function(dateStr) {
                let s = dateStr.split('.');
                let d = new Date(+s[2], s[1]-1, +s[0]);

                const today = new Date();
                // check if given date is in the future
                if (d > today){
                    return false;
                }

                // if age is bigger than 150 years
                if ((today.getFullYear() - d.getFullYear()) > 150){
                    return false;
                }

                if (Object.prototype.toString.call(d) === "[object Date]") {
                    if (!isNaN(d.getTime()) && d.getDate() == s[0] && d.getMonth() == (s[1] - 1)) {
                        return true;
                    }
                }
                return false;
            },

            clearErrorStore() {
                this.$store.commit('SubmittedValuesStore/setErrorKey', null);
                this.$store.commit('SubmittedValuesStore/clearErrorMessages');
            },

            isErrorsExists() {

                // if (typeof this.$route.query.error !== "undefined") {
                if (this.savedErrorKey != null) {
                    const validationErrors = ['invalidValueForParameters', 'invalidModuleForParamMed', 'invalidParamMedNameList', 'generalValidationError'];
                    if (this.savedErrorKey === "assessmentTokenExists") {
                        this.errorMessages.push(this.text("api.autologin.assessmentToken.exists"));
                        this.clearErrorStore();
                        return true;
                    }

                    if (this.savedErrorKey === "assessmentTokenFormatInvalid") {
                        this.errorMessages.push(this.text("api.autologin.assessmentToken.invalid"));
                        this.clearErrorStore();
                        return true;
                    }

                    if (this.savedErrorKey === "unauthorisedAccessToProduct" || this.savedErrorKey === "userNotRegistratedForProduct") {
                        this.errorMessages.push(this.text("api.autologin.unauthorised.access.product"));
                        this.clearErrorStore();
                        return true;
                    }

                    if (validationErrors.includes(this.savedErrorKey)) {
                        this.errorMessages = this.savedErrorMessages;
                        this.clearErrorStore();
                        return true;
                    }
                }
                return false;
            },
        }

    }
</script>

<style lang="scss">
.AutoLoginPage {
    height: 100vh;

    .auto-login-card {
        min-height: 400px;
        max-width: 600px;
        padding: 20px;
        justify-content: center;
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/components/auto-login/AutoLoginPage.vue